import { localeReducer } from './locale';
import { screenReducer } from './screen';
import { userReducer } from './user';
import type {
  ActiveFeatureConfigAction,
  CurrentVRCountryAction,
  GlobalContextAction,
  GlobalContextReducerState,
  LocaleAction,
  ScreenAction,
  UserAction
} from './types';
import { activeFeatureConfigReducer } from './activeFeatureConfig';
import { Portal } from '@dfg/brahma-types';
import { currentVRCountryReducer } from './currentVRCountry';

export const rootReducer = (
  {
    screen,
    locale,
    user,
    activeFeatureConfig,
    currentVRCountry
  }: GlobalContextReducerState,
  action: GlobalContextAction
): GlobalContextReducerState => ({
  screen: screenReducer(screen, action as ScreenAction),
  locale: localeReducer(locale, action as LocaleAction),
  user: userReducer(user, action as UserAction),
  activeFeatureConfig: activeFeatureConfigReducer(
    activeFeatureConfig,
    action as ActiveFeatureConfigAction
  ),
  portal: Portal.PARTNER,
  currentVRCountry: currentVRCountryReducer(
    currentVRCountry ?? { name: '' },
    action as CurrentVRCountryAction
  )
});
